<template>
  <div class="licorice-complete">
    <div class="licorice-complete__main">
      <span class="complete-message">これより、{{ nicknameMod }}専用の本を<br>お取り寄せします。少々お待ちください。</span>
      <p class="complete-info">
        <span>{{ resultLimit }}までにご連絡いたします。</span>
        <span><a href="/payment/library">申込み・購入済み</a>からもご覧いただけます。</span>
      </p>
      <img class="thanks" src="/static/img/licorice/detail/img_arigato.svg" v-if="!isSubscPresent">
    </div>
    <p class="licorice-complete__attention">
      【注意事項】
      <br>・占いビデオレターのお届けなど、お客様へのお知らせは、help@uranai.tvまたは、info@uranai.tvよりお送りします。受信設定のご確認をお願いします。
      <br>・お申し込み後の内容変更や払い戻しは承っておりません。
    </p>
    <!-- <sns-licorice :sharedata="sharedata" v-if="!isSubscPresent"></sns-licorice> -->
  </div>
</template>

<script>
  export default {
  name: "LicoriceComplete",
  data () {
    return {
      posterPath: '/static/img/licorice/detail/thum_movie.png',
      defSharedata: {
        twitter: {
          galabel: 'twitter_licorice'
        },
        line: {
          galabel: 'line_licorice'
        },
        facebook: {
          galabel: 'facebook_licorice'
        }
      }
    }
  },
  props: {
    nickname: {
      type: String,
      default: ''
    },
    resultLimit: {
      type: String,
      default: ''
    },
    textTwitter: {
      type: String,
      default: ''
    },
    textLine: {
      type: String,
      default: ''
    },
    userProfile: {
      type: Object,
      default() {
        return {}
      }
    },
    isSubscPresent: {
      type: Boolean,
      default() {
        return false
      }
    }
  },
  computed: {
    nicknameMod() {
      return this.nickname !== '' ? `${this.nickname}さま` : 'あなた'
    },
    sharedata () {
      const res = {}
      res.twitter = {
        text: this.textTwitter,
        galabel: this.defSharedata.twitter.galabel
      }
      res.line = {
        text: this.textLine,
        galabel: this.defSharedata.line.galabel
      }
      res.facebook = {
        galabel: this.defSharedata.facebook.galabel
      }
      return res
    }
  }
}
</script>

<style scoped lang="scss">
@import '../../../sass/variables/index';
.licorice-complete {
  margin: 0 -16px;
  width: 100vw;
  @include mq () {
    width: 580px;
  }
  &::after {
    content: '';
    display: block;
    width: 100%;
    height: 7px;
    background: $gray-light;
  }
  &__main {
    width: 100%;
    padding-top: 80vw;
    padding-bottom: 22px;
    background: url('/static/img/licorice/detail/bg_tsukishiro.png') no-repeat center top #1D110A;
    background-size: 100% auto;
    color: $brown-9;
    position: relative;

    @include mq (){
      padding-top: 464px;
    }
    .complete-message {
      width: 100%;
      display: block;
      font-family: $font_mincho;
      text-align: center;
      font-size: 14px;
      line-height: 22px;
      margin-bottom: 24px;
    }
    .complete-info {
      width: calc(100% - 22px - 22px);
      height: 64px;
      background: $brown-4;
      border: 1px solid $brown-5;
      border-radius: 5px;
      margin: auto;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      text-align: center;
      font-size: 12px;
      line-height: 21px;
      font-family: $font_mincho;
      span {
        width: 100%;
      }
      a {
        color: #F4D88E;
      }
    }
    .thanks {
      display: block;
      width: calc(100% - 3vw - 3vw);
      position: absolute;
      left: 0;
      top: 40vw;
      right: 0;
      margin: auto;
      @include mq () {
        width: 548px;
        top: 230px;
      }
    }
  }
  &__attention {
    width: 100%;
    color: $brown-4;
    background: $brown-7;
    padding: 24px 12px;
    font-size: 12px;
    line-height: 20px;
    margin: 0;
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/LicoriceComplete.vue